import { createBrowserRouter, RouterProvider } from "react-router";
import Home from "./pages/home";
import Release from "./pages/release";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/r/:id",
    element: <Release />,
  },
  {
    path: "*",
    element: <div>404 Not Found</div>,
  },
]);

export default function App() {
  return (
    <div style={{ position: "absolute", width: "100%", height: "100%", zIndex: 999 }}>
      <RouterProvider router={router} />
    </div>
  );
} 